<mat-card class="cardWithShadow">
    <mat-card-content>
        <mat-card-title class="header">
            Documentos - Plantillas
            <button mat-stroked-button color="primary" (click)="openEditDialog($event)">Nueva Plantilla</button>
        </mat-card-title>
        <div *ngIf="dataSource.length>0; else spinnersection" class="main-container">
            <div>
                <table mat-table [dataSource]="dataSource" style="border-radius: 10px;" class="mat-elevation-z8">
            
                    <ng-container matColumnDef="name">
                        <th mat-header-cell *matHeaderCellDef class="title"> Nombre </th>
                        <td mat-cell *matCellDef="let element"> {{element.name}} </td>
                    </ng-container>

                    <ng-container matColumnDef="description">
                        <th mat-header-cell *matHeaderCellDef class="title"> Descripción </th>
                        <td mat-cell *matCellDef="let element"> {{element.description}} </td>
                    </ng-container>

                    <ng-container matColumnDef="used">
                        <th mat-header-cell *matHeaderCellDef class="title"> Usada en </th>
                        <td mat-cell *matCellDef="let element"> {{getUsedName(element.used)}} 
                            <mat-icon matTooltip="Editar" style="color: #67686a; cursor: pointer; margin-right: 15px;" (click)="openEditUsedDialog($event,element)">create</mat-icon>
                        </td>
                    </ng-container>
                
                    <ng-container matColumnDef="createdDate">
                        <th mat-header-cell *matHeaderCellDef class="title"> Fecha de creación </th>
                        <td mat-cell *matCellDef="let element"> {{element.createdAt | date : 'dd/MM/yyyy'}} </td>
                    </ng-container>
    
                    <ng-container matColumnDef="modifiedDate">
                        <th mat-header-cell *matHeaderCellDef class="title"> Fecha de modificación </th>
                        <td mat-cell *matCellDef="let element"> {{element.modifiedAt | date : 'dd/MM/yyyy'}} </td>
                    </ng-container>
                
                    <ng-container matColumnDef="modifiedBy">
                        <th mat-header-cell *matHeaderCellDef class="title"> Modificado por </th>
                        <td mat-cell *matCellDef="let element"> {{element.modifiedBy}} </td>
                    </ng-container>
                
                    <ng-container matColumnDef="actions">
                        <th mat-header-cell *matHeaderCellDef class="title"> Acciones </th>
                        <td mat-cell *matCellDef="let element">
                            <!--<mat-icon matTooltip="Ver" style="color: #003c8a; cursor: pointer; margin-right: 15px;" (click)="previewDocument(element.templateId)">visibility</mat-icon>-->
                            <mat-icon matTooltip="Editar" style="color: #67686a; cursor: pointer; margin-right: 15px;" (click)="openEditDialog($event,element)">create</mat-icon>
                            <mat-icon matTooltip="Borrar" style="color: red; cursor: pointer;" (click)="onDelete($event,element)">delete</mat-icon>
                        </td>
                    </ng-container>
                
                    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns;" (click)="previewDocument(row.templateId)"></tr>
                </table>
            </div>
        </div>
    </mat-card-content>
</mat-card>

<ng-template #spinnersection>
    <section style="display:flex; justify-content: center;">
        <mat-spinner diameter="60"></mat-spinner>
    </section>
</ng-template>